import { Injectable } from '@angular/core';
import { TxApiService } from './txapi.service';
import { Observable } from 'rxjs';
import {
	ListOfWorkflowGroup,
	TxWorkflow,
	TxWorkflowCalendarProtokoll,
	TxWorkflowCalendarRequest,
	TxWorkflowRequest,
} from '../interfaces/workflow';
import { map, share } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class WorkflowService {
	constructor(private myTxApiService: TxApiService) {}

	getWorkflowCalendar(fullYear = 0, teamleader = 0): Observable<TxWorkflowCalendarProtokoll> {
		const myWorkflowCalendarRequestData = new TxWorkflowCalendarRequest();
		myWorkflowCalendarRequestData.full_year = fullYear;
		myWorkflowCalendarRequestData.team_leader = teamleader;
		return this.myTxApiService.callAPI('getWfCalendar', myWorkflowCalendarRequestData);
	}

	getWorkflow(teamleader = 0): Observable<TxWorkflow> {
		const myWorkflowRequestData = new TxWorkflowRequest();
		myWorkflowRequestData.from = '2010-02-01T04:58:21';
		myWorkflowRequestData.to = '2026-12-08T04:58:21';
		myWorkflowRequestData.team_leader = teamleader;
		return this.myTxApiService.callAPI('getWorkflow', myWorkflowRequestData);
	}

	getWorkflowCalendarUpdate(startDate: string, endDate: string, teamLeaderFor = 0): Observable<TxWorkflowCalendarProtokoll> {
		// Use similar format as other workflow requests
		const requestData = {
			startDate: startDate + 'T00:00:00', // Full datetime format like other endpoints
			endDate: endDate + 'T23:59:59',     // Full datetime format like other endpoints  
			team_leader_for: teamLeaderFor,
			sessionid: '',  // Will be set by TxApiService
		};
		return this.myTxApiService.callAPI('getWfCalendarUpdate', requestData);
	}

	getWorkflowGroups(): Observable<Array<ListOfWorkflowGroup>> {
		return this.myTxApiService.callAPI('getWfGroups', {}).pipe(
			map((data) => {
				return data.ListOfWorkflowGroup;
			}),
			share()
		);
	}
}
